import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { PurchasePlusPageInfoFragmentDoc } from './PageInfo.generated'
import { SelectOrganisationAdminListOrganisationFragmentDoc } from './SelectOrganisationAdminListOrganisation.generated'
import * as Types from './purchasePlus_graphql'

export const GetSwitchOrganisationModalSelectOrganisationDocument = gql`
  query GetSwitchOrganisationModalSelectOrganisation(
    $filters: OrganisationsQueryFiltersInput
    $after: String
    $before: String
    $first: Int
    $last: Int
    $sorts: [OrganisationsQuerySortsInput!]
    $adminScope: Boolean
  ) {
    organisations(
      after: $after
      before: $before
      first: $first
      last: $last
      filters: $filters
      sorts: $sorts
      adminScope: $adminScope
    ) {
      edges {
        node {
          ...SelectOrganisationAdminListOrganisation
        }
      }
      pageInfo {
        ...PurchasePlusPageInfo
      }
    }
  }
  ${SelectOrganisationAdminListOrganisationFragmentDoc}
  ${PurchasePlusPageInfoFragmentDoc}
` as unknown as DocumentNode<
  Types.GetSwitchOrganisationModalSelectOrganisationQuery,
  Types.GetSwitchOrganisationModalSelectOrganisationQueryVariables
>
